import apiClient from './axios';

export type BrokerType = 'zerodha' | 'icici_direct' | 'motilal_oswal';

export interface PortfolioHolding {
  id: number;
  trading_symbol: string;
  stock_name: string;
  isin: string;
  exchange: string;
  quantity: number;
  average_price: number;
  last_price: number;
  current_value: number;
  invested_value: number;
  pnl: number;
  pnl_pct: number;
  day_change_pct: number;
}

export interface PortfolioSummary {
  total_invested: number;
  current_value: number;
  total_pnl: number;
  total_pnl_pct: number;
  holdings_count: number;
}

export interface PortfolioUploadInfo {
  broker: string;
  filename: string;
  uploaded_at: string;
}

export interface PortfolioResponse {
  holdings: PortfolioHolding[];
  summary: PortfolioSummary;
  upload: PortfolioUploadInfo | null;
}

export async function fetchPortfolioHoldings(): Promise<PortfolioResponse> {
  const response = await apiClient.get('/portfolio/holdings/');
  return response.data;
}

export async function uploadPortfolioCSV(file: File, broker: BrokerType): Promise<{ message: string; holdings_count: number }> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('broker', broker);

  const response = await apiClient.post('/portfolio/upload/', formData, {
    headers: { 'Content-Type': undefined },
  });
  return response.data;
}

export async function deletePortfolio(): Promise<{ message: string }> {
  const response = await apiClient.delete('/portfolio/holdings/');
  return response.data;
}

// --- Portfolio Doctor: Health Check Types ---

export interface SectorAllocation {
  sector: string;
  percentage: number;
  value: number;
  stock_count: number;
}

export interface RiskFlag {
  type: 'concentration' | 'quality' | 'valuation' | 'momentum';
  severity: 'high' | 'medium' | 'low';
  title: string;
  description: string;
  affected_stocks: string[];
}

export interface PortfolioHealthCheckResult {
  health_score: number;
  summary: string;
  sector_breakdown: SectorAllocation[];
  top_holdings_concentration: number;
  avg_roe: number;
  avg_pe: number;
  risk_flags: RiskFlag[];
  recommendations: string[];
  stocks_analyzed: number;
  stocks_not_found: string[];
  analyzed_at: string;
}

export async function analyzePortfolio(): Promise<PortfolioHealthCheckResult> {
  const response = await apiClient.post('/portfolio/analyze/');
  return response.data;
}
